// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "TabsHeader-module--wrapper--BMiDm";
export var pageTitle = "TabsHeader-module--pageTitle--0dhmV";
export var tabsWrapper = "TabsHeader-module--tabsWrapper--w03Za";
export var tabs = "TabsHeader-module--tabs--cWusb";
export var item = "TabsHeader-module--item--qXcl4";
export var active = "TabsHeader-module--active--ep-QN";
export var hidden = "TabsHeader-module--hidden--kr8ua";
export var nawWrapper = "TabsHeader-module--nawWrapper--M-UyK";
export var counter = "TabsHeader-module--counter--1ZnB1";
export var arrowNext = "TabsHeader-module--arrowNext--Q0z9K";
export var selectWrapper = "TabsHeader-module--selectWrapper--zK1b4";
export var selectList = "TabsHeader-module--selectList--LWXW9";
export var input = "TabsHeader-module--input--NGLZ2";
export var dropDownIcon = "TabsHeader-module--dropDownIcon---c5P7";
export var bgBlock = "TabsHeader-module--bgBlock--qXkLH";